import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { Container, PageHeader } from "../components/ui-kit";
import { LEGAL } from "../mock";

const COOKIES = [
  { name: "Zorunlu çerezler", provider: "Koşan Düğme (birinci taraf)", purpose: "Sitenin temel işlevlerinin çalışması ve çerez tercihinizin hatırlanması.", type: "Zorunlu", life: "Oturum / kalıcı" },
  { name: "Analitik / performans çerezleri", provider: "Analitik hizmet sağlayıcı (üçüncü taraf, yurt dışı)", purpose: "Ziyaret istatistiklerinin anonim olarak ölçülmesi ve site deneyiminin iyileştirilmesi.", type: "Açık rızaya tabi (opt-in)", life: "Kalıcı" },
];

const Cookies = () => (
  <main className="bg-canvas" data-testid="cookies-page">
    <Seo
      title="Çerez Politikası — Koşan Düğme"
      description="Koşan Düğme web sitesinde kullanılan çerezler, türleri, amaçları ve çerez tercihlerinizi nasıl yönetebileceğiniz."
      path="/cerez-politikasi"
    />
    <Breadcrumbs items={[{ label: "Çerez Politikası", to: "/cerez-politikasi" }]} />
    <PageHeader
      eyebrow="Yasal · Çerezler"
      title="Çerez Politikası"
      text="Web sitemizde kullanılan çerezler ve tercihlerinizi nasıl yönetebileceğiniz hakkında bilgi."
    />
    <Container className="py-16 lg:py-20 max-w-3xl">
      <div className="space-y-10">
        <section>
          <h2 className="font-display font-light text-2xl text-ink">Çerez Nedir?</h2>
          <p className="text-ink2 leading-relaxed mt-4 text-[15px]">
            Çerezler, ziyaret ettiğiniz web siteleri tarafından tarayıcınıza kaydedilen küçük metin dosyalarıdır. Sitenin
            düzgün çalışmasını sağlamak ve deneyiminizi iyileştirmek için kullanılırlar.
          </p>
        </section>

        <section>
          <h2 className="font-display font-light text-2xl text-ink">Kullandığımız Çerezler</h2>
          <p className="text-ink2 leading-relaxed mt-4 text-[15px]">
            Zorunlu olmayan (analitik) çerezler yalnızca <strong>açık rızanız</strong> ile çalışır ve siteye ilk
            girişte varsayılan olarak kapalıdır.
          </p>
          <div className="mt-6 space-y-4">
            {COOKIES.map((c) => (
              <div key={c.name} className="border border-line bg-paper p-5" data-testid="cookie-row">
                <p className="font-semibold text-ink text-[15px]">{c.name}</p>
                <dl className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-2 text-[13px]">
                  <div><dt className="inline text-mute">Sağlayıcı: </dt><dd className="inline text-ink2">{c.provider}</dd></div>
                  <div><dt className="inline text-mute">Tür: </dt><dd className="inline text-ink2">{c.type}</dd></div>
                  <div className="sm:col-span-2"><dt className="inline text-mute">Amaç: </dt><dd className="inline text-ink2">{c.purpose}</dd></div>
                  <div><dt className="inline text-mute">Saklama: </dt><dd className="inline text-ink2">{c.life}</dd></div>
                </dl>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="font-display font-light text-2xl text-ink">Çerez Tercihlerinizi Yönetme</h2>
          <p className="text-ink2 leading-relaxed mt-4 text-[15px]">
            Siteye ilk girişinizde görüntülenen çerez bilgilendirme bandından analitik çerezleri kabul edebilir veya
            reddedebilirsiniz. Tercihinizi dilediğiniz zaman tarayıcınızın ayarlarından çerezleri silerek yeniden
            belirleyebilirsiniz. Zorunlu çerezler sitenin çalışması için gereklidir ve devre dışı bırakılamaz.
          </p>
          <p className="text-ink2 leading-relaxed mt-4 text-[15px]">
            Kişisel verilerinizin işlenmesine ilişkin ayrıntılar için{" "}
            <Link to="/kvkk-aydinlatma-metni" className="text-ink font-medium hover:text-brand transition-colors">KVKK Aydınlatma Metni</Link>
            {" "}ve{" "}
            <Link to="/gizlilik" className="text-ink font-medium hover:text-brand transition-colors">Gizlilik Politikası</Link>
            {" "}sayfalarımızı inceleyebilirsiniz.
          </p>
        </section>

        <p className="text-[12px] text-mute pt-4 border-t border-line">Son güncelleme: {LEGAL.updated}.</p>
      </div>
    </Container>
  </main>
);

export default Cookies;
